// extracted by mini-css-extract-plugin
export default {"tabList":"TabList_tabList__Ry9Nj"};